export default {
      id: "yandex-maps-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "app/svg/sprite.svg#yandex-maps",
      toString: function () {
        return this.url;
      }
    }